import axios from 'axios';

axios.defaults.withCredentials = true;

export async function changePass(token, password) {
  try {
    const response = await axios.post(`${import.meta.env.VITE_APP_API_URL}change-pass`, { token, password });

    return response

  } catch (error) {
    console.error('Error al cambiar la contraseña', error);
  }
}